import {CHANGE_DEV_MODE} from '../mutations/available'

export const toggleDevMode = async({commit, state}) => {
    commit(CHANGE_DEV_MODE, !state.devMode)
}